import { updateVisibleStates } from "../subdiagram-viewer";
import RappidContext from "./rappid-context";
import { dia } from "@clientio/rappid";

export default class RappidController {
  constructor(private context: RappidContext) {}

  activate() {
    this.context.graph.on("add", (cell) => {
      const view = this.context.paper.findViewByModel(cell);
      this.context.controllers.get(view)?.on("add");
    });
    this.context.graph.on("remove", (cell) => {
      const view = this.context.paper.findViewByModel(cell);
      this.context.controllers.get(view)?.on("remove");
    });
    this.context.graph.on("change", (cell) => {
      const view = this.context.paper.findViewByModel(cell);
      this.context.controllers.get(view)?.on("change");
    });
    this.context.paper.on("link:connect", (linkView, evt, elementViewConnected) => {
      this.context.controllers.get(elementViewConnected)?.on("link:connect", { evt });
    });
    this.context.paper.on("link:disconnect", (linkView, evt, elementViewDisconnected) => {
      this.context.controllers.get(elementViewDisconnected)?.on("link:disconnect", { evt });
    });
    this.context.paper.on("cell:pointerdown", (cellView: dia.CellView, evt: dia.Event) => {
      this.context.controllers.get(cellView)?.on("cell:pointerdown", { evt });
    });
    this.context.paper.on("cell:pointerup", (cellView: dia.CellView, evt: dia.Event) => {
      this.context.controllers.get(cellView)?.on("cell:pointerup", { evt });
    });
    this.context.paper.on("element:pointerdown", (elementView: dia.ElementView, evt: dia.Event) => {
      this.context.controllers.get(elementView)?.on("element:pointerdown", { evt });
    });
    this.context.paper.on("element:pointermove", (elementView: dia.ElementView, evt: dia.Event) => {
      this.context.controllers.get(elementView)?.on("element:pointermove", { evt });
    });
    this.context.paper.on("element:pointerup", (elementView: dia.ElementView, evt: dia.Event) => {
      this.context.controllers.get(elementView)?.on("element:pointerup", { evt });
    });
    this.context.paper.on("element:pointermove", (elementView: dia.ElementView, evt: dia.Event) => {
      this.context.controllers.get(elementView)?.on("element:pointermove", { evt });
    });
    this.context.paper.on("cell:pointerdblclick", (elementView: dia.CellView, evt: dia.Event) => {
      this.context.controllers.get(elementView)?.on("cell:pointerdblclick", { evt });
    });
    this.context.stencil.on("element:drop", (elementView: dia.ElementView, evt: dia.Event) => {
      this.context.controllers.get(elementView)?.on("element:drop", { evt });
    });
    this.context.graph.on("reset", () => {
      this.context.paper.once("render:done", () => {
        updateVisibleStates(this.context, null);
      });
    });
  }
}
